import React, { useState, useEffect, useCallback } from "react";
import { Button } from "primereact/button";
import { api } from "../../../../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../../../../components/Loader/LoaderBlue";
import { scrollToTop } from "../../../../../../../../../utility/scrollToTop";
import "./ESIMProfileDialog.css";

export const ESIMProfileDialog = ({ setVisible, cpData, toast }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [copiedKey, setCopiedKey] = useState("");

  useEffect(() => {
    scrollToTop(true);
  }, []);

  const fetchESIMProfile = useCallback(async () => {
    setIsLoading(true);
    try {
      const payload = {
        sim: cpData?.esn ?? cpData?.esnId?.esn ?? cpData?.simNumber ?? "",
        enrollmentId: cpData?.enrollmentId ?? cpData?._id ?? "",
      };
      const res = await api.post(`/api/user/getESIMProfile`, payload);
      setProfileData(res?.data?.data || res?.data);
    } catch (error) {
      if (toast?.current) {
        toast.current.show({
          severity: "error",
          summary: "eSIM Profile",
          detail:
            error?.response?.data?.msg ||
            error?.response?.data?.message ||
            "Failed to fetch eSIM Profile",
          life: 3000,
        });
      }
    } finally {
      setIsLoading(false);
    }
  }, [cpData, toast]);

  useEffect(() => {
    fetchESIMProfile();
  }, [fetchESIMProfile]);

  const copyToClipboard = (text, key) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(""), 2000);
    if (toast?.current) {
      toast.current.show({
        severity: "success",
        summary: "Copied",
        detail: "Copied to clipboard!",
        life: 2000,
      });
    }
  };

  const qrImageUrl =
    profileData?.qrCodeUrl ||
    (profileData?.qrCode?.startsWith("data:") ||
    profileData?.qrCode?.startsWith("http")
      ? profileData?.qrCode
      : profileData?.qrCode
        ? `data:image/png;base64,${profileData.qrCode}`
        : null) ||
    profileData?.qr_code;

  return (
    <div
      style={{ width: "108.4rem" }}
      className="flex flex-wrap flex-row justify-content-center "
    >
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <div
        style={{ top: "42rem", position: "absolute", zIndex: 10000 }}
        className="AddAdhoc-main"
      >
        <div className="adhoc-topheader">
          <h1>eSIM Profile & QR Code</h1>
          <p>
            View eSIM profile details and scan QR code for instant activation
          </p>
        </div>

        <div className="adhoc-customer-details">
          <div className="adhoc-customer-details-item">
            <p>Customer</p>
            <p>
              {cpData?.firstName && cpData?.lastName
                ? `${cpData.firstName} ${cpData.lastName}`
                : cpData?.firstName || "NIL"}
            </p>
          </div>
          <div className="adhoc-customer-details-item">
            <p>Customer ID</p>
            <p>{cpData?.enrollmentId || "NIL"}</p>
          </div>
          <div className="adhoc-customer-details-item">
            <p>Telephone Number</p>
            <p>{cpData?.contact || cpData?.phoneNumber || "NIL"}</p>
          </div>
          <div className="adhoc-customer-details-item">
            <p>SIM / ESN</p>
            <p>
              {profileData?.iccid || cpData?.esn || cpData?.esnId?.esn || "NIL"}
            </p>
          </div>
        </div>

        {isLoading ? (
          <div
            className="flex justify-content-center align-items-center w-full"
            style={{ minHeight: "18rem" }}
          >
            <CommonLoaderBlue customSize={12} />
          </div>
        ) : profileData ? (
          <div className="esim-adhoc-body">
            <div className="esim-adhoc-qr-box">
              {qrImageUrl ? (
                <img src={qrImageUrl} alt="eSIM QR Code" />
              ) : (
                <p
                  style={{
                    color: "#8b8ba7",
                    fontSize: "1.2rem",
                    textAlign: "center",
                  }}
                >
                  No QR Code Available
                </p>
              )}
            </div>

            <div className="esim-adhoc-fields">
              <div className="esim-adhoc-field-item">
                <label>Matching ID / Activation Code</label>
                <div className="field-val-row">
                  <span>
                    {profileData?.matchingId ||
                      profileData?.activationCode ||
                      "NIL"}
                  </span>
                  {(profileData?.matchingId || profileData?.activationCode) && (
                    <button
                      type="button"
                      className="copy-btn"
                      onClick={() =>
                        copyToClipboard(
                          profileData?.matchingId ||
                            profileData?.activationCode,
                          "matchingId",
                        )
                      }
                    >
                      <i
                        className={
                          copiedKey === "matchingId"
                            ? "pi pi-check"
                            : "pi pi-copy"
                        }
                      />
                      {copiedKey === "matchingId" ? "Copied" : "Copy"}
                    </button>
                  )}
                </div>
              </div>

              <div className="esim-adhoc-field-item">
                <label>SM-DP+ Address</label>
                <div className="field-val-row">
                  <span>
                    {profileData?.smdpAddress || profileData?.smdp || "NIL"}
                  </span>
                  {(profileData?.smdpAddress || profileData?.smdp) && (
                    <button
                      type="button"
                      className="copy-btn"
                      onClick={() =>
                        copyToClipboard(
                          profileData?.smdpAddress || profileData?.smdp,
                          "smdp",
                        )
                      }
                    >
                      <i
                        className={
                          copiedKey === "smdp" ? "pi pi-check" : "pi pi-copy"
                        }
                      />
                      {copiedKey === "smdp" ? "Copied" : "Copy"}
                    </button>
                  )}
                </div>
              </div>

              {profileData?.confirmationCode && (
                <div className="esim-adhoc-field-item">
                  <label>Confirmation Code</label>
                  <div className="field-val-row">
                    <span>{profileData.confirmationCode}</span>
                    <button
                      type="button"
                      className="copy-btn"
                      onClick={() =>
                        copyToClipboard(
                          profileData.confirmationCode,
                          "confirmation",
                        )
                      }
                    >
                      <i className="pi pi-copy" /> Copy
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div
            className="flex flex-column justify-content-center align-items-center w-full"
            style={{ minHeight: "14rem", gap: "1.2rem" }}
          >
            <p style={{ color: "#72728f", fontSize: "1.4rem" }}>
              No eSIM profile data found for this customer.
            </p>
            <Button
              label="Retry"
              icon="pi pi-refresh"
              className="btn-primary"
              style={{
                width: "12rem",
                height: "3.8rem",
                backgroundColor: "#475ced",
                color: "white",
              }}
              onClick={fetchESIMProfile}
            />
          </div>
        )}

        <div className="action-buttons-container">
          <Button
            label="Cancel"
            type="button"
            onClick={() => setVisible(false)}
          />
          {qrImageUrl && (
            <Button
              label="Print QR"
              icon="pi pi-print"
              type="button"
              onClick={() => {
                const printWin = window.open("", "_blank");
                printWin.document.write(`
                  <html>
                    <head><title>eSIM QR Code - ${cpData?.phoneNumber || ""}</title></head>
                    <body style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:90vh;font-family:sans-serif;">
                      <h2>eSIM Activation QR Code</h2>
                      <p><strong>Customer:</strong> ${cpData?.firstName || ""} ${cpData?.lastName || ""}</p>
                      <p><strong>MDN:</strong> ${cpData?.phoneNumber || "NIL"}</p>
                      <p><strong>ICCID:</strong> ${profileData?.iccid || cpData?.esn || "NIL"}</p>
                      <img src="${qrImageUrl}" style="width:25rem;height:25rem;margin:2rem;" />
                      ${profileData?.matchingId ? `<p><strong>Matching ID:</strong> ${profileData.matchingId}</p>` : ""}
                      ${profileData?.smdpAddress ? `<p><strong>SM-DP+:</strong> ${profileData.smdpAddress}</p>` : ""}
                    </body>
                  </html>
                `);
                printWin.document.close();
                printWin.focus();
                setTimeout(() => {
                  printWin.print();
                }, 500);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
